export const defaultStatus = {
    inProgress: false,
    success: false,
    error: false,
    data: [],
    message: null,
    errormessage: null,
    errorFields: null,
  };
  